export default __webpack_public_path__ + "static/media/custom_webhook.799feb0e.svg";